import { useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import CollapsibleRow from '../components/CollapsibleRow';
import AgentsPerformanceTableRow from './AgentsPerformanceTableRow';

export default function AgentsPerformanceGroupedTableContent() {
  const { agentsPerformance } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );

  return (
    <Table.Rows>
      {agentsPerformance.branches.map((branch) => {
        const items = [
          `${branch.branch?.name} (${branch.agents?.length ?? 0})`,
          branch.assigned_contacts.value,
          branch.saved_searches.value,
          branch.shared_files.value,
          branch.events.value,
          branch.completed_operations.value,
        ];

        return (
          <CollapsibleRow key={branch.id} items={items}>
            {branch?.agents?.map((agent, index) => (
              // eslint-disable-next-line
              <AgentsPerformanceTableRow key={index} row={agent} />
            ))}
          </CollapsibleRow>
        );
      })}
    </Table.Rows>
  );
}
